// extracted by mini-css-extract-plugin
module.exports = {"tab":"HelpCenter_tab__3aTf5","activeTab":"HelpCenter_activeTab__MWqUt","paper":"HelpCenter_paper___UhZ-","mapContainer":"HelpCenter_mapContainer__1Syph"};